import axios from "axios";
import { authHeaderJson } from "../auth-header.service";
import { WEB_AUTH_URL, WEB_CORE_URL } from "../../configurations/paths.config"
import { isNullUndefinedOrEmpty } from "../../common/Helpers";

const getUsersLEBU = (legal_entity_id, bu_id) => {
    //[##PATH ROUTE##]
    return axios.get(`/api/env/getUsersLEBU/${isNullUndefinedOrEmpty(legal_entity_id) ? 0 : legal_entity_id}/${isNullUndefinedOrEmpty(bu_id) ? 0 : bu_id}`, { headers: authHeaderJson() } )
};

const getUsersByElementId = async (elementId) => {
    return axios.get(`/api/env/usersByElementId/${elementId}`, { headers: authHeaderJson() } )
};

const getSecurityProps = (userName) => {
    return axios.get(`${WEB_CORE_URL}/api/Privilege/securityProps?username=${ userName }`, { headers: authHeaderJson() } )
};

const generateSkh = async (userName) => {
    let config = { method: 'post', url: `${WEB_AUTH_URL}/api/account/generate-skh?userName=${encodeURIComponent(userName)}`, headers: authHeaderJson() };
    return await axios(config);
};

const healthcheck = (userName) => {
    return axios.get(`${WEB_AUTH_URL}/api/account/healthcheck?userName=${encodeURIComponent(userName)}`, { headers: authHeaderJson() });
};

const getClientSubMenu = () => {
    return axios.get(`/api/Env/getorganizationmenu`, { headers: authHeaderJson() })  
};

export {
    getUsersLEBU,
    getSecurityProps,
    generateSkh,
    getUsersByElementId,
    healthcheck,
    getClientSubMenu
}